define(
	'actions/students',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes",
	"constants/login-images",
	"shared/crm"
	],
	function($,_,Backbone,React,AppDispatcher,Constants, LoginImages, CRM){
		return Backbone.Model.extend({
			STUDENT_CHUNK_SIZE: 32,
			init: function(params) {
			},
			pulling: [],
			dispatchAddStudents: function(data) {
				AppDispatcher.dispatch({
					actionType: Constants.ADD_STUDENTS,
					data: data
				});
			},
			dispatchUpdateStudent: function(data) {
				AppDispatcher.dispatch({
					actionType: Constants.UPDATED_STUDENT,
					data: data
				});
			},
			initStudent: function(data) {
				var submissions_count = {};
				var auth_image_set = [];

				if (data.source !== 'clever' && data.source !== 'classlink') {
					$.each(data.submissions_count, function(section_guid, submission_count) {
						submissions_count[section_guid.toLowerCase()] = submission_count;
					});

					if (data.supports_image_set_auth) {
						auth_image_titles = data.auth_image_set;
						auth_image_set = LoginImages.filter(function (image) {
							return auth_image_titles.indexOf(image.title) >= 0;
						});
					}
				}

				let id = "";
				let guid = null;
				if (data.source === 'clever') {
					id = data.clever_id;

					if (!data.clever_id) {
						id = data.guid;
					}

					guid = data.guid
				} else if (data.source === 'classlink') {
					id = data.classlink_id;

					if (!data.classlink_id) {
						id = data.guid;
					}

					guid = data.guid
				} else {
					id = data.guid;
				}

				return {
					id: id,
					buncee_user_guid: guid,
					auth_image_set: auth_image_set,
					first_name: data.first_name,
					last_name: data.last_name,
					username: data.username,
					section_guid: data.section_guid,
					group_guid: data.group_guid,
					avatar: data.avatar,
					links: data.links,
					buncees_count: data.buncees_count,
					submissions_count: submissions_count,
					locked_because: data.locked_because,
					source: data.source,
					badges: data.badges || [],
					supports_image_set_auth: data.supports_image_set_auth
				};
			},
			pullClassLink: function (guid) {
				var self = this;
				var students = [];
				if(guid) {
					this.pulling.push(guid);
					window.api.request("users", guid).execute().done(function(response) {
						students.push(self.initStudent(response.data));
					}, function() {
						self.pulling.slice(self.pulling.indexOf(guid), 1);
						self.dispatchAddStudents(students);
					});
				} else {
					window.api.request("classlink/mystudents").each(function iterator(index, response) {
						students.push(self.initStudent(response.data));
					}, function() {
						self.dispatchAddStudents(students);
					});
				}
			},
			pullClever: function (guid) {
				var self = this;
				var students = [];
				if(guid) {
					this.pulling.push(guid);
					window.api.request("users", guid).execute().done(function(response) {
						students.push(self.initStudent(response.data));
					}, function() {
						self.pulling.slice(self.pulling.indexOf(guid), 1);
						self.dispatchAddStudents(students);
					});
				} else {
					window.api.request("clever/mystudents").each(function iterator(index, response) {
						students.push(self.initStudent(response.data));
					}, function() {
						self.dispatchAddStudents(students);
					});
				}
			},
			pull: function (guid) {
				var self = this;
				var students = [];
				if(guid) {
					this.pulling.push(guid);
					window.api.request("users", guid).execute().done(function(response) {
						students.push(self.initStudent(response.data));
					}, function() {
						self.pulling.slice(self.pulling.indexOf(guid), 1);
						self.dispatchAddStudents(students);
					});
				} else {
					window.api.request("students").each(function iterator(index, response) {
						students.push(self.initStudent(response.data));
					}, function() {
						self.dispatchAddStudents(students);
					});
				}
			},
			createStudents: function(sectionId, studentsList, success, failure) {
				var self = this;
				var ConnectToStores = require("shared/connect-to-stores");
				var section = ConnectToStores.classes.get(sectionId);

				if(section.source == "google-classroom") {
					if(typeof failure == "function") {
						failure("Cannot create students in the section created in "+ section.source +".");
					}
					return;
				}

				var passwordsMap = {};
				studentsList.forEach(function(student) {
					// For now we will drop the auth image set key so that it is not used accidentally.
					// Delete when we actually want to create students with image logins.

					// if (student.auth_image_set !== null) {
					// 	student.password = null;
					// }
					delete student['auth_image_set'];

					passwordsMap[student.username.toLowerCase()] = student.password;
				});

				var newStudents = [], student_csvData = [];
				var callback = function() {
					// Add students into section's student list
					if(section) {
						section.students = section.students.concat(newStudents.map(function(student) {
							return student.id;
						}));
					}
					
					// Add students into students list
					self.dispatchAddStudents(newStudents);

					if(typeof success == "function") {
						success(student_csvData);
					}
				}

				var recursiveCreate = function(studentsList, callback) {
					var users = studentsList.splice(0, self.STUDENT_CHUNK_SIZE);
					var data = {
						users: JSON.stringify(users),
						section_guid: sectionId
					};
					var promise = window.api.request("students", "bulk").create(data);

					promise.done(function(response) {
						response.data.forEach(function(student) {
							student.data.password = passwordsMap[student.data.username.toLowerCase()];
							student_csvData.push(student.data);

							student = self.initStudent(student.data);

							newStudents.push(student);
						});

						// If still there're more chunks
						if(studentsList.length > 0) {
							recursiveCreate(studentsList, callback);
						}
						else {
							CRM.event('student:create');
							callback();
						}
					});

					promise.fail(function(response) {
						if(typeof failure == "function") {
							failure(response, users);
						}
					});
				};

				recursiveCreate(studentsList, callback);
			},
			updateStudent: function(id, data, success, failure) {
				var self = this;
				var ConnectToStores = require("shared/connect-to-stores");
				var student = ConnectToStores.students.get(id);

				if(student.source == "google-classroom") {
					if(typeof failure == "function") {
						failure("Cannot update student created in "+ student.source +".");
					}
					return;
				}

				_.each(Object.keys(data), function(key) {

					if (data[key] === student[key] || data[key] === "") {
						delete data[key];
						return;
					}
					
					if (key === "auth_image_set") {

						data[key] = data[key].map(function (image) {
							return image.title
						});
						
						data[key] = data[key].length > 0 ? data[key] : null;

						// if (data[key].length > 0) {
						// 	data[key][0] = data[key][0].title;
						// 	data[key][1] = data[key][1].title;
						// }
					}
				});

				if(Object.keys(data).length == 0) {
					if(typeof success == "function") {
						success();
					}

					return;
				}

				var request = window.api.request("students", id);
				// request.xhrParams.processData = false;
				// request.xhrParams.contentType = "application/x-www-form-urlencoded";
				var promise = request.update(data);

				promise.done(function(response) {
					student = self.initStudent(response.data);
					self.dispatchUpdateStudent(student);

					CRM.event('student:update');

					if(typeof success == "function") {
						success();
					}
				});

				promise.fail(function(response) {
					if(typeof failure == "function") {
						failure();
					}
				});
			},
			unlockStudent: function(id, success, failure) {
				var self = this;
				
				var ConnectToStores = require("shared/connect-to-stores");
				var student = ConnectToStores.students.get(id);

				var request = window.api.request("students", id, "unlock");
				var promise = request.create({});

				promise.done(function(response) {
					var studentCopy = $.extend({},student);
					studentCopy.locked_because = null;
					console.log("original: " + student.locked_because);
					console.log("copy: " + studentCopy.locked_because);
					self.dispatchUpdateStudent(studentCopy);

					if(typeof success == "function") {
						success();
					}
				});

				promise.fail(function(response) {
					if(typeof failure == "function") {
						failure();
					}
				});
			},
			updatePasswordStudents: function(studentsList, data, success, failure) {
				var self = this;
				var result = [];
				var password = data.password;

				data['auth_image_set'] = data['auth_image_set'].map(function (image) {
					return image.title
				});
				data['auth_image_set'] = data['auth_image_set'].length > 0 ? data['auth_image_set'] : null;
				var auth_image_set = data.auth_image_set;

				if (auth_image_set != null && auth_image_set.length == 2) {
					delete data['password'];
					delete data['password_confirmation'];
				}

				studentsList = studentsList.map(function(student) {
					return student.id;
				})

				var callback = function() {
					if(typeof success == "function") {
						success(result);
					}
				}

				var recursiveUpdate = function(studentsList, callback) {
					var users = studentsList.splice(0, self.STUDENT_CHUNK_SIZE);
					var params = $.extend(data, { users: JSON.stringify(users) });
					var promise = window.api.request("students", "bulk").update(params);

					promise.done(function(response) {
						var students = response.data.map(function(student) {
							if (auth_image_set) {
								student.data.auth_image_set = auth_image_set;
							} else {
								student.data.password = password;
							}
							
							var updatedStudent = self.initStudent(student.data);
							self.dispatchUpdateStudent(updatedStudent);

							result.push(student.data);
						});

						if(studentsList.length > 0) {
							recursiveUpdate(studentsList, callback);
						}
						else {
							CRM.event('student:updatePassword');
							callback();
						}
					});

					promise.fail(function(response) {
						if(typeof failure == "function") {
							failure("Failed to update account(s). Please try again.");
						}
					});
				};

				recursiveUpdate(studentsList, callback);
			},
			importStudentsFromCSV: function(csvFile, showResults) {
				var self = this;

				var request = window.api.request("students", "csv");
				request.xhrParams.processData = false;
				request.xhrParams.contentType = false;

				var formData = new FormData();
				formData.append("csv", csvFile);

				request.create(formData).done(function(response) {
					showResults(response.data);
					CRM.event('student:importCSV');
				});
			}
		});
	}
);
